import {
    Component, OnInit, isDevMode,
    ViewChild,
    AfterViewInit, OnDestroy
} from '@angular/core';
import {
    FormsService, ParametersService, SubtitlesService, AppAlertService,
    ViewsService
} from '../core';
import {StateService} from '@uirouter/core';
import {RegistrationData} from "../models";
import {RecaptchaComponent} from "ng-recaptcha";

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit, AfterViewInit, OnDestroy  {
  captcha_key = this.forms.captcha_key
  username: string = '';
  email: string = '';
  password: string = '';
  confirmedPassword: string = '';
  acceptGeneralPolicy: boolean = false;
  acceptPolicy: boolean = false;
  acceptRegulations: boolean = false;
  acceptRulesService24: boolean = false;
  createAccountButtonDisable: boolean = false;
  validUsername: boolean | null = null;
  validEmail: boolean | null = null;
  validPassword: boolean | null = null;
  validConfirmedPassword: boolean | null = null;
  recaptchaResponse: string | null = null;
  showRecaptcha: boolean = true;
  @ViewChild('captchaRef') captchaComponent?: RecaptchaComponent;

  constructor(
      protected forms: FormsService,
      private $state: StateService,
      private parameters: ParametersService,
      public subtitles: SubtitlesService,
      public appAlert: AppAlertService,
      public views: ViewsService,
  ) {
  }

  ngOnInit() {
    this.setRegisterButtonStatus();
    this.showRecaptcha = !isDevMode();
    if(isDevMode()){
      this.forms.validCaptcha = true;
      this.recaptchaResponse = 'test';
    }
  }

  ngAfterViewInit() {
    this.views.checkCaptchaIsReady();
  }

  ngOnDestroy() {
    this.views.hideCaptchaLoader();
  }

  goToState(state: string): void{
    this.$state.go(state);
  }

  setRegisterButtonStatus() {
    this.createAccountButtonDisable = !this.acceptRegulations || !this.acceptGeneralPolicy
        || !this.acceptPolicy || !this.acceptRulesService24 || this.recaptchaResponse.length === 0;
  }

  validateUsername() {
    const regex = /^[a-zA-Z]([a-zA-Z0-9]{5,25})$/;
    this.validUsername = regex.test(this.username);
  }

  validatePassword() {
    this.validPassword = this.password.length >= 8;
    if (this.validConfirmedPassword !== null) {
      this.confirmedPassword = '';
      this.validConfirmedPassword = null;
    }
  }

  subtitle(id: number): string {
    return this.subtitles.setSubtitle(id);
  }

  validateConfirmedPassword() {
    this.validConfirmedPassword = (this.password === this.confirmedPassword && this.confirmedPassword.length >= 8);
  }

  validateEmail() {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.validEmail = regex.test(this.email);
  }

  loginScreen() {
    this.$state.go('login', {selectedModuleHash: this.parameters.selectedModuleHash});
  }

  resolved(captchaResponse: string) {
    this.recaptchaResponse = captchaResponse;
    this.setRegisterButtonStatus();
  }

  createAccount() {
    this.createAccountButtonDisable = true;
    this.validateUsername();
    this.validPassword = this.password.length >= 8;
    this.validateConfirmedPassword();
    this.validateEmail();

      if (!this.recaptchaResponse) {
          this.forms.validCaptcha = false;
      } else {
          this.forms.validCaptcha = true;
      }

    if(isDevMode()){
      this.forms.validCaptcha = true;
    }

    let errorsNumber = 0;
    let message = '<div class="text-align-left font-13">';

    if (!this.validUsername) {
      errorsNumber += 1;
      message += errorsNumber + '. ' + this.subtitles.setSubtitle(3399) + '<br>';
    }

    if (!this.validPassword) {
      errorsNumber += 1;
      message += errorsNumber + '. ' + this.subtitles.setSubtitle(1932) + '<br>';
    }

    if (!this.validConfirmedPassword) {
      errorsNumber += 1;
      message += errorsNumber + '. ' + this.subtitles.setSubtitle(1341) + '<br>';
    }

    if (!this.validEmail) {
      errorsNumber += 1;
      message += errorsNumber + '. ' + this.subtitles.setSubtitle(1342) + '<br>';
    }

    if (!this.forms.validCaptcha) {
      errorsNumber += 1;
      message += errorsNumber + '. ' + this.subtitles.setSubtitle(3386) + '<br>';
    }

    if (!this.acceptPolicy || !this.acceptGeneralPolicy) {
      errorsNumber += 1;
      message += errorsNumber + '. ' + this.subtitles.setSubtitle(5168) + '<br>';
    }

    if (this.forms.isCompanySubdomain('kolton')) {
      if (!this.forms.validCity) {
        errorsNumber += 1;
        message += errorsNumber + '. ' + this.subtitles.setSubtitle(7165) + '<br>';
      }
      if (!this.forms.validStreet) {
        errorsNumber += 1;
        message += errorsNumber + '. ' + this.subtitles.setSubtitle(7166) + '<br>';
      }
      if (!this.forms.validHouseNumber) {
        errorsNumber += 1;
        message += errorsNumber + '. ' + this.subtitles.setSubtitle(448) + '<br>';
      }
      if (!this.forms.validPhone) {
        errorsNumber += 1;
        message += errorsNumber + '. ' + this.subtitles.setSubtitle(3385) + '<br>';
      }
      if (!this.forms.validInstallerInformation) {
        errorsNumber += 1;
        message += errorsNumber + '. ' + this.subtitles.setSubtitle(5354) + '<br>';
      }
    }

    message += '</div>';

    if (errorsNumber > 0) {
      this.createAccountButtonDisable = false;
      this.appAlert.showAppAlert(message, this.subtitles.setSubtitle(1136), null, false, null);
    } else {
      const data: RegistrationData = {
        username: this.username,
        password: this.password,
        confirm_password: this.confirmedPassword,
        email: this.email,
        captcha: this.recaptchaResponse,
        language: this.subtitles.language,
        accept_regulations: true,
        accept_privacy_policy: true,
        accept_mobile_privacy_policy: true,
        accept_rules_service24: true,
      };

      if (this.forms.isCompanySubdomain('kolton')) {
        this.forms.contactForm.email = this.email;
        data.contactForm = this.forms.contactForm;
      }

      this.forms.submitRegistration(data).subscribe({
          next: (response: any) => {
            if (response && response.code === 1) {
              let alert = this.subtitles.setSubtitle(1169) + ' ' + this.subtitles.setSubtitle(1943);
              this.appAlert.showAppAlert(alert, this.subtitles.setSubtitle(1129), () => this.$state.go('login', {}), false, null);
              this.createAccountButtonDisable = false;
            } else {
              // Handle other cases where response.code may not be 1
            }
          },
          error: (errorResponse: any) => {
            const { error } = errorResponse.error;

            let alert = '';
            switch (error.code) {
              case -8:
                alert = this.subtitles.setSubtitle(5354);
                break;
              case -7:
                alert = this.subtitles.setSubtitle(3385);
                break;
              case -6:
                alert = this.subtitles.setSubtitle(448);
                break;
              case -5:
                alert = this.subtitles.setSubtitle(7166);
                break;
              case -4:
                alert = this.subtitles.setSubtitle(7165);
                break;
              case -3:
                alert = this.subtitles.setSubtitle(1941);
                break;
              case -2:
                alert = this.subtitles.setSubtitle(1445);
                break;
              case -1:
                alert = this.subtitles.setSubtitle(1168);
                break;
              case 0:
                alert = this.subtitles.setSubtitle(1167);
                break;
              default:
                alert = '';
            }

            this.appAlert.showAppAlert(alert, this.subtitles.setSubtitle(1136), null, false, null);
            this.createAccountButtonDisable = false;
          }
      });
    }
  }
}
